import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import {
  DocumentReviewPayload,
  ReferralDetail,
  UpdateStartOfCareDatePayload,
} from "../../../models/Referral";
import {
  documentDownload,
  getAuthPacket,
  getReferralAuthHistory,
  postUpdateStartOfCareDate,
  postDocumentReview,
} from "../../../actions/ReferralAction";
import AuthorizationDetails from "../components/AuthorizationDetails";
import { GetAuthPacketActionDispatchTypes } from "../../../constants/HomePage";
import { setDefaultInfoForReAuth } from "../../../actions/Patient";
import { UserPageTrack } from "../../../models/User";
import { postUserPageTrack } from "../../../actions/UserAction";
import { resetStates } from "../../../actions/Common";

const mapStateToProps = ({
  referralAuthHistoryState,
  authPacketDownloadState,
  documentReviewState,
  documentDownloadState,
  updateStartOfCareDateState,
}: ApplicationState) => ({
  referralAuthHistory:
  referralAuthHistoryState.response,
  authPacketDownload: authPacketDownloadState.response,
  documentReviewListData: documentReviewState.response,
  documentReviewListDataLoading: documentReviewState.loading,
  documentDownloadData: documentDownloadState,
  updateStartOfCareDateState,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    getReferralAuthHistory: (referralId: number) => {
      dispatch(getReferralAuthHistory(referralId));
    },
    getAuthPacket: (referralId: number, patientId: number) => {
      dispatch(getAuthPacket(referralId, patientId));
    },
    resetAuthPacket: () => {
      dispatch({
        type: GetAuthPacketActionDispatchTypes.GET_AUTH_PACKET_RESET,
      });
    },
    setDefaultInfoForReAuth: (payload: ReferralDetail) => {
      dispatch(setDefaultInfoForReAuth(payload));
    },
    postDocumentReview: (payload: DocumentReviewPayload) => {
      dispatch(postDocumentReview(payload));
    },
    documentDownload: (blobId: number) => {
      dispatch(documentDownload(blobId));
    },
    postUserPageTrack: (payload: UserPageTrack) => {
      dispatch(postUserPageTrack(payload));
    },
    updateSoC: (payload: UpdateStartOfCareDatePayload) => {
      dispatch(postUpdateStartOfCareDate(payload));
    },
    resetStates: (actionType: string) => {
      dispatch(resetStates(actionType));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AuthorizationDetails);
